import { getMonthName } from '../../utils/index';

const getDateString = (date) => date?.toISOString().substring(0, 10);

/* istanbul ignore next */
export const getCouponExpirationDate = (date) => {
    const today = new Date();
    const tomorrow = new Date();
    const expiryDate = new Date(date);
    tomorrow.setDate(today.getDate() + 1);
    const todayDateString = getDateString(today);
    const tomorrowDateString = getDateString(tomorrow);
    const expiryDateString = getDateString(expiryDate);
    if (todayDateString === expiryDateString) {
        return 'Today';
    }
    if (tomorrowDateString === expiryDateString) {
        return 'Tomorrow';
    }
    return `${getMonthName(expiryDate.getMonth())} ${expiryDate.getDate()}`;
};

export const getLineCountMargin = (linecount) => {
    let lineCountStyle = [];
    switch (linecount) {
        case 0:
            lineCountStyle = [];
            break;
        case 1:
            lineCountStyle = ['lg:-mt-3'];
            break;
        case 2:
            lineCountStyle = ['md:-mt-4', 'lg:-mt-7'];
            break;
        case 3:
            lineCountStyle = ['md:-mt-7', 'lg:-mt-11'];
            break;
        default:
            lineCountStyle = [];
    }
    return lineCountStyle;
};
